'use strict';

const TypeofFilter = () => {
    'ngInject';

    return (object) => {
        return typeof object;
    };
};

export default TypeofFilter;



// WEBPACK FOOTER //
// ./src/app/common/core/filters/typeof.filter.js